import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PotentialDuplicatedMember } from '../models/PotentialDuplicatedMember';
import PaginationRequest from '../models/PaginationRequest';
import { PagedList } from '../models/PagedList';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentDuplicatesService extends BaseService {

  constructor(protected http: HttpClient, protected authService: AuthService) 
  {
    super(authService, http);
  }
  
  apiUrl = environment.LRNEXT_API_URL + '/enrollment-duplicates';

  getPotentialDuplicates(pagination: PaginationRequest, searchTerm: string, status?: any): Observable<PagedList<PotentialDuplicatedMember>>{
    
    let url = `${this.apiUrl}?page=${pagination.page}&pageSize=${pagination.pageSize}`;
    if (pagination.orderByField) {
      url = url.concat(`&orderByField=${pagination.orderByField}`);
    }
    if (pagination.orderBy) {
      url = url.concat(`&orderBy=${pagination.orderBy}`);
    }
    if(searchTerm){
      url = url.concat(`&searchTerm=${searchTerm}`);
    }
    if (status) {
      url = url.concat(`&status=${status}`);
    }
      return this.get<PagedList<PotentialDuplicatedMember>>(url);
  }

  getPendingCount(): Observable<{ count: number }> {
    return this.get<{ count: number }>(`${this.apiUrl}/pending-count`);
  }

  acceptNew(newSubId: number, oldSubId: number): Observable<any>{
    
    const url = `${this.apiUrl}/accept-new/${newSubId}?selectedDuplicateId=${oldSubId}`;
    return this.post(url, null);
  }

  merge(newSubId: number, oldSubId: number): Observable<any>{
    
    const url = `${this.apiUrl}/merge/${newSubId}?selectedDuplicateId=${oldSubId}`;
    return this.post(url, null);
  }

  noAction(newSubId: number): Observable<any>{
    
    const url = `${this.apiUrl}/no-action/${newSubId}`;
    return this.post(url, null);
  }
}
